var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 11.9919V11.1671C32.0001 10.3397 31.7809 9.52685 31.3644 8.81027C30.948 8.09369 30.349 7.49864 29.6276 7.08493L18.3724 0.631446C17.6511 0.21778 16.8329 0 16 0C15.1671 0 14.3489 0.21778 13.6276 0.631446L2.37239 7.0867C1.65102 7.5004 1.05201 8.09546 0.635567 8.81204C0.219122 9.52862 -8.29341e-05 10.3415 2.35376e-08 11.1689V12.2759L1.51181 13.0088V11.6455C1.51172 10.9366 1.69958 10.2401 2.05648 9.62622C2.41339 9.01231 2.92676 8.50259 3.54495 8.14834L13.557 2.40654V5.16727L3.92157 10.6958V23.6098L13.557 29.136V31.8968L3.54495 26.1561C2.92671 25.8016 2.41332 25.2917 2.05642 24.6776C1.69953 24.0635 1.51169 23.3669 1.51181 22.6578V14.9706L2.35376e-08 14.2377V23.1338C-8.29341e-05 23.9612 0.219122 24.7741 0.635567 25.4907C1.05201 26.2072 1.65102 26.8023 2.37239 27.216L13.6152 33.663C13.8446 33.7944 14.0847 33.9068 14.3328 33.9988V1.96055L14.9781 1.59057C15.2963 1.40787 15.6573 1.31156 16.0249 1.31131H16.032C16.4312 1.3116 16.8221 1.42482 17.1589 1.6377L17.6666 1.96055V34C17.9154 33.9088 18.1559 33.7966 18.3854 33.6648L29.627 27.2178C30.3484 26.8041 30.9474 26.209 31.3638 25.4924C31.7803 24.7758 31.9995 23.963 31.9994 23.1356V13.9608L30.4876 14.7102V22.6554C30.4877 23.3644 30.3 24.0609 29.9433 24.6749C29.5867 25.289 29.0736 25.799 28.4556 26.1538L18.4436 31.8956V29.136L28.0778 23.6075V10.6958L18.4436 5.16845V2.40654L28.4551 8.14834C29.0729 8.50283 29.586 9.01264 29.9427 9.62651C30.2994 10.2404 30.4871 10.9367 30.487 11.6455V12.7407L32 11.9919ZM13.5547 19.7598L5.4737 14.983V11.5883L13.5547 6.95414V19.7598ZM22.2785 16.8141L24.0904 17.8851L26.5221 19.3226V22.7143L18.4424 27.3486V14.5447L22.2785 16.8141Z",
    fill: "url(#paint0_linear_653_9156)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_653_9156",
    x1: 16,
    y1: -1.41878,
    x2: 16,
    y2: 35.3774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B16D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1AA36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FCD74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F1AA36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E38C05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FCD74E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F1AA36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#B16D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1AA36"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldCoin);
export default __webpack_public_path__ + "static/media/goldCoin.6f0481349915f83a7e845a436a6f0b9e.svg";
export { ForwardRef as ReactComponent };